
import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { Customer } from '../models/customer.model';

@Injectable()
export class CustomersGroupService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    getSourceCustomers(id: number) {
        return this.http.get('api/Customer/GetSourceCustomers/' + id, this.getAuthHeader(true));
    }

    getSourceCustomersForFacility(facilityTypeId: number) {
        return this.http.get('api/Customer/GetSourceCustomersByFacility/' + facilityTypeId, this.getAuthHeader(true));
    }

    getTargetCustomers(id: number) {
        return this.http.get('api/Customer/GetTargetCustomers/' + id, this.getAuthHeader(true));
    }

    updateCustomerGroup(id: number, groupName: string, facilityTypeId: number, targetCustomers: Customer[]) {
        var data = {
            customerId: id,
            targetCustomers: targetCustomers,
            groupName: groupName,
            facilityTypeId: facilityTypeId
        }

        return this.http.post('api/Customer/UpdateCustomerGroup', data, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/customers-group.service.ts